import { render, staticRenderFns } from "./DrugSearchDashboardItemSba.vue?vue&type=template&id=601aeab0&scoped=true&"
import script from "./DrugSearchDashboardItemSba.vue?vue&type=script&lang=js&"
export * from "./DrugSearchDashboardItemSba.vue?vue&type=script&lang=js&"
import style0 from "./DrugSearchDashboardItemSba.vue?vue&type=style&index=0&id=601aeab0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601aeab0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCol,VCombobox,VForm,VIcon,VListItemAction,VListItemContent,VListItemTitle,VRow})
